<template>
  <div>
    <div :class="{ 'd-flex flex-wrap': twoColumns }">
      <opq-text-field
        :code="adresseCode"
        :id="'adresse-' + carteAffaire.id"
        v-model="carteAffaire.adresse"
        :live="liveSasCartesAffaires(2912)"
        ref="adresse"
        :class="{ 'mr-3': twoColumns }"
        autocomplete="off"
        :disabled="disabled"
      ></opq-text-field>

      <opq-text-field
        :code="complementAdresseCode"
        v-model="carteAffaire.complementAdresse"
        :live="liveSasCartesAffaires(2913)"
        optional
        ref="complementAdresse"
        :disabled="disabled"
      ></opq-text-field>
    </div>
    <template v-if="!noNoteAcces">
      <opq-text-field
        :code="noteAccesCode"
        v-model="carteAffaire.noteDAcces"
        :live="liveSasCartesAffaires(2933)"
        optional
        width="450"
        ref="noteAcces"
      ></opq-text-field>
    </template>
    <div :class="{ 'd-flex flex-wrap': twoColumns }">
      <opq-text-field
        :code="villeCode"
        v-model="carteAffaire.ville"
        :live="liveSasCartesAffaires(2914)"
        ref="ville"
        :class="{ 'mr-3': twoColumns }"
        :disabled="disabled"
      ></opq-text-field>

      <opq-text-field
        :code="codePostalCode"
        v-model="carteAffaire.codePostal"
        is-code-postal
        :code-pays="codePays(carteAffaire.pays)"
        :live="liveSasCartesAffaires(2916)"
        ref="codePostal"
        :disabled="disabled"
      ></opq-text-field>
    </div>

    <div :class="{ 'd-flex flex-wrap': twoColumns }">
      <opq-catalogue
        :code="provinceCode"
        v-model="carteAffaire.province"
        :opq-if="paysEstUSouCA(carteAffaire.pays)"
        :parent="carteAffaire.pays"
        order-by="text"
        :live="liveSasCartesAffaires(2915)"
        ref="province"
        :class="{ 'mr-3': twoColumns }"
        :disabled="disabled"
      >
      </opq-catalogue>

      <opq-catalogue :code="paysCode" v-model="carteAffaire.pays" order-by="text" :live="liveSasCartesAffaires(2917)" ref="pays" :disabled="disabled">
      </opq-catalogue>
    </div>

    <template v-if="!noEmail">
      <opq-text-field
        :code="courrielCode"
        v-model="carteAffaire.courriel"
        is-email
        :live="liveSasCartesAffaires(2920)"
        :optional="courrielOptional"
      ></opq-text-field>
    </template>

    <template v-if="!noPhone">
      <opq-text-field
        :code="telephoneCode"
        v-model="carteAffaire.numeroTelephone"
        is-phone-number
        :code-pays="codePays(carteAffaire.pays)"
        :live="liveSasCartesAffaires(2918)"
      ></opq-text-field>
    </template>
    <template v-if="!noPosteTelephonique">
      <opq-text-field
        :code="posteTelephoniqueCode"
        v-model="carteAffaire.posteTelephonique"
        optional
        :live="liveSasCartesAffaires(2919)"
      ></opq-text-field>
    </template>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"

export default {
  mixins: [CataloguesHelper],
  props: {
    carteAffaire: { type: Object },
    addressComplete: { type: Boolean, default: true },
    adresseCode: { type: String, default: "adresse" },
    complementAdresseCode: { type: String, default: "complement-adresse" },
    noteAccesCode: { type: String, default: "note-acces" },
    villeCode: { type: String, default: "ville" },
    codePostalCode: { type: String, default: "code-postal" },
    provinceCode: { type: String, default: "province" },
    paysCode: { type: String, default: "pays" },
    courrielCode: { type: String, default: "courriel" },
    telephoneCode: { type: String, default: "telephone" },
    posteTelephoniqueCode: { type: String, default: "poste-telephone" },
    twoColumns: { type: Boolean, default: false },
    endpoint: { type: String, default: "sas-cartes-affaires" },
    live: { type: Boolean, default: true },
    noPhone: { type: Boolean, default: false },
    noPosteTelephonique: { type: Boolean, default: false },
    noNoteAcces: { type: Boolean, default: false },
    noEmail: { type: Boolean, default: false },
    courrielOptional: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  mounted() {
    if (this.addressComplete) {
      this.setup()
    }
  },
  methods: {
    liveSasCartesAffaires(cle) {
      return this.live ? { endpoint: this.endpoint, cle: cle, fileId: this.carteAffaire.id } : null
    },
    updateChamps(address) {
      this.$refs.adresse.setValue(address.Line1)
      this.$refs.complementAdresse.setValue(address.Line2)
      this.$refs.ville.setValue(address.City)
      this.$refs.province.setValueByCode(address.ProvinceCode)
      this.$refs.codePostal.setValue(address.PostalCode)
      this.$refs.pays.setValueByCode(address.CountryIso2)
    },
    setup() {
      if (window.pca) {
        var fields = [{ element: "adresse-" + this.carteAffaire.id, field: "Line1", mode: window.pca.fieldMode.SEARCH }]
        var options = {
          key: process.env.VUE_APP_ADDRESSCOMPLETE_KEY
        }
        var control = new window.pca.Address(fields, options)

        control.listen("populate", (address) => {
          // Pour éviter que le code postal ne se remplisse pas à cause du v-facade, on doit déclencher 2 fois la modification du code postal.
          this.updateChamps(address)
          setTimeout(() => this.$refs.codePostal.setValue(address.PostalCode), 200)
        })
      } else {
        console.error("No AddressComplete (window.pca is undefined)")
      }
    }
  }
}
</script>

<style>
</style>